import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function CategorySection() {
  const [activeCategory, setActiveCategory] = useState('rexue');

  const filteredComics = comics.filter((c) => c.category === activeCategory);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-6 md:mb-8">
          <h2 className="text-lg md:text-xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            分类浏览
          </h2>
          <p className="text-xs md:text-sm text-foreground-500 mt-1">按分类找到你喜欢的<strong>漫画类型</strong></p>
        </div>

        <div className="flex items-center justify-center flex-wrap gap-2 mb-6 md:mb-8">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(cat.slug)}
              className={`px-4 py-2 text-sm rounded-full font-medium transition-all whitespace-nowrap cursor-pointer flex items-center gap-1.5 ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200/60'
              }`}
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${cat.icon} text-xs`}></i>
              </span>
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {filteredComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div className="text-center mt-6 md:mt-8">
          <Link
            to={`/category/${activeCategory}`}
            className="inline-flex items-center gap-1.5 px-6 py-2.5 text-sm font-medium rounded-full bg-background-50 text-foreground-700 border border-background-200/70 hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部{categories.find((c) => c.slug === activeCategory)?.name}漫画
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}